import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { PopoverInput } from './base/popover-input';

@Component({
	selector: 'popover-time',
	template: require('./popover-time.component.html')

})
export class PopoverTimeComponent extends PopoverInput {

	constructor() { super() }

	ngOnChanges(changes: SimpleChanges) {
		if (changes['originalValue']) {
			this.dirtyValue = changes['originalValue'].currentValue;
		}
	}

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/editable-popover/popover-time.component.ts